import type { ReactNode } from 'react'
import styles from './Pill.module.css'

type Tone = 'neutral' | 'accent' | 'success' | 'danger' | 'warning'

/**
 * Meaning is never carried by colour alone — a tone always arrives with an icon
 * or wording (CLAUDE.md > Design system), which is why `icon` sits first.
 */
export function Pill({
  tone = 'neutral',
  icon,
  children,
}: {
  tone?: Tone
  icon?: ReactNode
  children: ReactNode
}) {
  const toneClass = tone === 'neutral' ? '' : (styles[tone] ?? '')
  return (
    <span className={`${styles.pill} ${toneClass}`}>
      {icon}
      {children}
    </span>
  )
}
